export class CalendarOutlineLevel {
    //netgen start
    title: string;
    id = 0;
    //netgen end
}
